module.exports = __webpack_public_path__ + "img/1459255559.09048e73.jpg";